import { useQuery } from "react-query";
import axios from "axios";
import { baseURL } from "../constants/api";
import { getHeaders } from "./helper";
import useProfile from "./useProfile";

const getData = async (token) => {
  const config = getHeaders();

  if (!token) {
    return;
  } else {
    config.headers.ab_token = token;
  }

  const { data } = await axios.post(
    baseURL + "customerprofile/orderHistory",
    {},
    config
  );
  return data;
};

export default function useOrders() {
  const { data } = useProfile();

  return useQuery("orders", () => getData(data?.data?.token));
}
